import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect  from '../../componentes/formulario/MiSelect';

import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getApiUrl, axiosPost, getTitle, getCookieOptions, getDecodedCookie, translateTreeJson } from '../../helpers/helperApp';
import { getDataFromDB, storeDataInDB, clearAllData } from "../../helpers/CacheDbHelper";

import { Fragment } from 'react';

let backUpFormularioPrin = null;

function AppTrad(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, saveConfApp, getConfApp, setEncodedCookie } = useContext(LoginContext); 
    let { confApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, saveFilterRegs, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{
                    document.title = getTitle(confPantalla.config.trad, confPantalla.apptrad.title);                
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.apptrad.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.apptrad.hijo.estadoForm);                              
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                // Filtrar los registros por la opción de configuración que recibimos como parámetro
                                if( props.location.state ){ 
                                    if( "cfg" in props.location.state ){
                                        saveFilterRegs(props.location.state.cfg);
                                        setEncodedCookie('filterRegs', props.location.state.cfg, getCookieOptions());
                                    }                   
                                }
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.apptrad.padre.urls);
                                saveFormularioPrin(confPantalla.apptrad.padre.modelform);
                                saveFormularioHijo(confPantalla.apptrad.hijo.modelform);                                
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.apptrad.padre.urls, confPantalla.apptrad.hijo.urls, confPantalla.apptrad.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);     
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                   
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                cookies.remove('filterRegs', {path: '/'});
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
    
    const handleInputFormCatch = async (e, formularioPrin, saveFormularioPrin, control) => {       
        const idiomaUsu = getDecodedCookie('idioma');
        handleInputForm(e, formularioPrin, saveFormularioPrin);

        if((idiomaUsu == "en" && control == "inputEn") || (idiomaUsu == "es" && control == "inputEs")){
            let auxTrad = [];        
            const hoy = new Date().toISOString().split('T')[0]+'-'+idiomaUsu;        
            auxTrad[0] = {ori: idiomaUsu == 'en' ? formularioPrin.val_en : formularioPrin.val, tra: e.target.value};                  
            let auxConfApp = await getDataFromDB(hoy, 'confApp');        
            auxConfApp = await translateTreeJson(auxConfApp, auxTrad, confApp.config.trad.keystrad);
            await storeDataInDB(hoy, auxConfApp, 'confApp');
            saveConfApp(auxConfApp.msg);        
        }               
    }

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>     
            {
                confPantalla !== undefined
                ?
                    <Fragment>
                        <Menusup 
                            props = { props }
                        />
                        <Sidebar 
                            props = { props }
                        />
                    </Fragment>
                :
                null
            } 
            <div className="content-wrapper">
                <div className="content-header">
                </div>
                <section className="content">
                {
                        !tieneNivel 
                        ?
                            <PermissionRefused
                                traduction={confPantalla.config.trad.components.permissionrefused} 
                            />
                        :
                            <Fragment>
                            {
                                loadedConf === true && confPantalla !== undefined
                                ?
                                    <Section titulo={ confPantalla.apptrad.section.titulo } icono={ confPantalla.apptrad.section.icono } col={ confPantalla.apptrad.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.apptrad.section.wiki } >
                                            <Formulario 
                                                        estadoForm= { estadoFormPrin }
                                                        loading=    { loadReg ? true : false }
                                                        btnNew={ confPantalla.apptrad.padre.btnform.new }
                                                        btnSave={ confPantalla.apptrad.padre.btnform.save }
                                                        btnSaveAndNew={ confPantalla.apptrad.padre.btnform.saveandnew }
                                                        btnDelete={ confPantalla.apptrad.padre.btnform.delete }
                                                        btnClone={ confPantalla.apptrad.padre.btnform.clone }
                                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.apptrad.padre.urls, confPantalla.apptrad.padre.modelform, confPantalla.apptrad.padre.tabla, confPantalla.apptrad.hijo.modelform, confPantalla.apptrad.title) }
                                                        formulario = { formularioPrin } 
                                                        resetForm = { e => resetFormPrin(confPantalla.apptrad.padre.modelform, true, confPantalla.apptrad.padre.tabla) } 
                                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.apptrad.padre.urls, confPantalla.apptrad.padre.modelform, confPantalla.apptrad.padre.tabla, confPantalla.apptrad.title) } 
                                            >
                                                <FormRow clases="" >
                                                    <FormInput                                                        
                                                        estadoForm= { estadoFormPrin }
                                                        value=      { formularioPrin.txt }
                                                        loading=    { loadReg ? true : false }
                                                        id=         { confPantalla.apptrad.padre.controles.txt.id }   
                                                        type=       { confPantalla.apptrad.padre.controles.txt.type }  
                                                        name=       { confPantalla.apptrad.padre.controles.txt.name }   
                                                        label=      { confPantalla.apptrad.padre.controles.txt.label }                                                       
                                                        placeholder={ confPantalla.apptrad.padre.controles.txt.placeholder }    
                                                        col=        { confPantalla.apptrad.padre.controles.txt.col } 
                                                        required=   { confPantalla.apptrad.padre.controles.txt.required }
                                                        readonly=   { confPantalla.apptrad.padre.controles.txt.readonly }                                                
                                                        disabled=   { confPantalla.apptrad.padre.controles.txt.disabled }
                                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                        onBlur=     {null} 
                                                    />
                                                </FormRow>
                                                <FormRow clases="" >
                                                    <FormInput                                                        
                                                        estadoForm= { estadoFormPrin }
                                                        value=      { formularioPrin.val }
                                                        loading=    { loadReg ? true : false }
                                                        id=         { confPantalla.apptrad.padre.controles.val.id }   
                                                        type=       { confPantalla.apptrad.padre.controles.val.type }  
                                                        name=       { confPantalla.apptrad.padre.controles.val.name }   
                                                        label=      { confPantalla.apptrad.padre.controles.val.label }                                                       
                                                        placeholder={ confPantalla.apptrad.padre.controles.val.placeholder }    
                                                        col=        { confPantalla.apptrad.padre.controles.val.col } 
                                                        required=   { confPantalla.apptrad.padre.controles.val.required }
                                                        readonly=   { confPantalla.apptrad.padre.controles.val.readonly }                                                
                                                        disabled=   { confPantalla.apptrad.padre.controles.val.disabled }
                                                        // change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                        change=     { e => handleInputFormCatch(e, formularioPrin, saveFormularioPrin, "inputEs") }
                                                        onBlur=     {null} 
                                                    />
                                                </FormRow>
                                                <FormRow clases="" >
                                                    <FormInput                                                        
                                                        estadoForm= { estadoFormPrin }
                                                        value=      { formularioPrin.val_en }
                                                        loading=    { loadReg ? true : false }
                                                        id=         { confPantalla.apptrad.padre.controles.val_en.id }   
                                                        type=       { confPantalla.apptrad.padre.controles.val_en.type }  
                                                        name=       { confPantalla.apptrad.padre.controles.val_en.name }   
                                                        label=      { confPantalla.apptrad.padre.controles.val_en.label }                                                       
                                                        placeholder={ confPantalla.apptrad.padre.controles.val_en.placeholder }    
                                                        col=        { confPantalla.apptrad.padre.controles.val_en.col } 
                                                        required=   { confPantalla.apptrad.padre.controles.val_en.required }
                                                        readonly=   { confPantalla.apptrad.padre.controles.val_en.readonly }                                                
                                                        disabled=   { confPantalla.apptrad.padre.controles.val_en.disabled }
                                                        // change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                        change=     { e => handleInputFormCatch(e, formularioPrin, saveFormularioPrin, "inputEn") }
                                                        onBlur=     {null} 
                                                    />
                                                </FormRow>
                                                <FormRow>
                                                    <FormInput                                                        
                                                        estadoForm= { confPantalla.documentos.padre.estadoform }
                                                        value=      { formularioPrin.lec }
                                                        loading=    { loadReg ? true : false }
                                                        id=         { confPantalla.apptrad.padre.controles.lec.id }   
                                                        type=       { confPantalla.apptrad.padre.controles.lec.type }  
                                                        name=       { confPantalla.apptrad.padre.controles.lec.name }   
                                                        label=      { confPantalla.apptrad.padre.controles.lec.label }                                                       
                                                        placeholder={ confPantalla.apptrad.padre.controles.lec.placeholder }    
                                                        col=        { confPantalla.apptrad.padre.controles.lec.col } 
                                                        required=   { confPantalla.apptrad.padre.controles.lec.required }
                                                        readonly=   { confPantalla.apptrad.padre.controles.lec.readonly }                                                
                                                        disabled=   { confPantalla.apptrad.padre.controles.lec.disabled }
                                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                        onBlur=     {null} 
                                                    />
                                                </FormRow>
                                                
                                            </Formulario>                                  
                                            <MiDataTable
                                                formulario={formularioPrin} 
                                                estadoForm= { "readonly" }
                                                id={"apptrad"}
                                                columnas={confPantalla.apptrad.padre.datatable.columns}
                                                data={registrosPrin}
                                                buttons={confPantalla.apptrad.padre.datatable.buttons}
                                                ordering={confPantalla.apptrad.padre.datatable.ordering}
                                                order={confPantalla.apptrad.padre.datatable.order}
                                                searching={confPantalla.apptrad.padre.datatable.searching}
                                                paging={confPantalla.apptrad.padre.datatable.paging}
                                                select={confPantalla.apptrad.padre.datatable.select}
                                                pagelength={confPantalla.apptrad.padre.datatable.pagelength}
                                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.apptrad.padre.urls, confPantalla.apptrad.hijo.urls, confPantalla.apptrad.padreshijos, confPantalla.apptrad.hijo.modelform, confPantalla.apptrad.padre.tabla) }
                                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.apptrad.padre.urls, confPantalla.apptrad.padre.modelform, confPantalla.apptrad.padre.tabla, confPantalla.apptrad.title) }
                                                saveLoadingTable={ saveLoadingTable }
                                                loadingTable={loadingTable}
                                                columnactions={confPantalla.apptrad.padre.datatable.columnactions.title}
                                                traduction={confPantalla.config.trad.components.datatable}
                                            />        
                                    </Section>
                                :
                                    <LoadingPage />
                            }
                            </Fragment>
                }
                </section>
            </div>
        <Footer />        
        </div>

    );

}
export default AppTrad